// removed by extract-text-webpack-plugin
module.exports = {"s":"src-components-Section----section-module---s---2haFJ","c":"src-components-Section----section-module---c---1b2mK","o":"src-components-Section----section-module---o---sHSnZ","h":"src-components-Section----section-module---h---_Gb9a","t":"src-components-Section----section-module---t---fxE1i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Section/section.module.scss
// module id = 311
// module chunks = 204899606439113